import React, { Component } from "react";
import { Checkbox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import SelectedCardinality from "./Field/SelectedCardinality";
import CardinalityOptionsField from "./Field/CardinalityOptionsField";
import ShowMore from "../Display/ShowMore";
import EditorActions from "../Shared/Edit/EditorActions";
import ErrorMessage from '../Shared/Error/ErrorMessage'
import { callApiWithAuthorization } from "../../API/CallApi";
import { addToChangeHistory } from "../Helpers/Project/Project";
import { OverlayLoader } from "../Shared/Loader/OverlayLoader"
import { ATTRIBUTE_LABEL } from "../Helpers/Labels/AttributeLabel";
import { ENTITY_LABEL, ENTITY_PLURAL_LABEL } from "../Helpers/Labels/EntityLabel";
import { checkIfContradictiveRelationsExist } from "./utils";
import { isNullOrUndefined } from "../Helpers/miscellaneous";
import { withTranslation } from "react-i18next";
import { createReferenceAttribute, deleteEntityRelationReferenceAttribute, updateEntityRelation, updateReferenceAttribute } from "../../API/EntityRelations/EntityRelations";
import { getAttributes, updateAttribute } from "../../API/Attribute/Attribute";
import { getCurrentSubscriptionForOrganisation } from "../../API/Payment/Payment";
import Upgrade from "../Shared/Subscription/Upgrade";

const DEFAULT_REFERENCED_ATTRIBUTE = {
    attributeName: `Select ${ATTRIBUTE_LABEL}`,
    _id: "",
    rel_id: "",
}

class LinkedEntitySidebar extends Component {
    saveButton = React.createRef();

    RelationOptions = ["1", "many"];
    entityAttributeMap = {};

    AttributeItem = (li, itemProps) => {
        let prefix = "";

        if (itemProps.dataItem.inherited === "true") {
            prefix = "(i)";

            if (itemProps.dataItem.relName) {
                prefix = "(ia)";
            }
        }

        const itemChildren = (
            <span>
                {li.props.children} {prefix}
                {itemProps.dataItem.relName
                    ? "- " + itemProps.dataItem.relName
                    : ""}
            </span>
        );

        return React.cloneElement(li, li.props, itemChildren);
    };

    attributes = [];

    constructor(props) {
        super(props);

        this.state = {
            disabled: true,
            relationId: "",
            relationIdentifier: "",
            relationName: "",
            cardinality: "",
            newCardinality: "",
            reverseRelationName: "",
            showReferenceAttribute: false,
            referencedAttribute: {},
            lookupAttribute: {},
            fromEntity: {},
            toEntity: {},
            inherited: false,
            nameExists: false,
            targetAttributes: [],
            attributesLoading: true,
            showAdditionalFields: false,
            showChangeCardinalityPopup: false,
            preventReferenceAttribute: false,
            isLookupRequired: false,
            updatingRelationship: false,
            showDuplicateIdentifierError: false,
            contradictiveRelationError: {
                isValid: true,
                message: ""
            },
            identifierError: {
                isValid: true,
                message: ""
            },
            relationLabelError: {
                isValid: true,
                message: ""
            },
            reverseRelationLabelError: {
                isValid: true,
                message: ""
            },
            subscription: {},
            showUpgradeDialog: false
        };
    }

    render() {

        const { t } = this.props;

        return (
            <>
                {this.state.showUpgradeDialog && (
                    <Upgrade
                        toggleDialog={() => {
                            this.setState({ showUpgradeDialog: false });
                        }}
                        organization={{ id: this.props.organizationId }}
                    />
                )}
                {this.state.showChangeCardinalityPopup && (
                    /* refactored - ali */
                    <Dialog
                        title={t("cardinality_popup.title", { ns: "linked_entity/common" })}
                        onClose={this.toggleCardinalityPopup}
                        width={'90%'}
                    >
                        <form>
                            <span className="mt-2 me-2">
                                <ErrorMessage
                                    valid={this.state.contradictiveRelationError.isValid}
                                    error={this.state.contradictiveRelationError.message}
                                />
                            </span>
                            <CardinalityOptionsField
                                showCardinalityLabel={false}
                                selected={this.state.newCardinality}
                                firstEntityName={this.state.fromEntity.name}
                                secondEntityName={this.state.toEntity.name}
                                onSelect={this.handleCardinality}
                            />
                            <DialogActionsBar layout="end">
                                <div className="w-100 d-flex justify-content-end">
                                    <button
                                        onClick={this.toggleCardinalityPopup}
                                        className="btn btn-secondary"
                                    >
                                        {t("cardinality_popup.buttons.cancel", { ns: "linked_entity/common" })}
                                    </button>
                                    <button
                                        onClick={this.updateCardinality}
                                        disabled={this.isCardinalityChanged()}
                                        className="btn btn-primary"
                                    >
                                        {t("cardinality_popup.buttons.update", { ns: "linked_entity/common" })}
                                    </button>
                                </div>
                            </DialogActionsBar>
                        </form>
                    </Dialog>
                )}
                <div className="h-100">
                    <div className="d-flex flex-column h-100">
                        {
                            this.state.updatingRelationship &&
                            <OverlayLoader />
                        }
                        <div className="ps-1">
                            <EditorActions
                                header={this.props.t("title", { ns: "linked_entity/property_panel" })}
                                value={`${this.state.fromEntity.name} - ${this.state.toEntity.name}`}
                                disabled={true}
                                valuePlaceholder={`Linked ${ENTITY_LABEL} Name`}
                                active={
                                    this.state.disabled ||
                                    this.state.showDuplicateIdentifierError ||
                                    this.state.showError ||
                                    this.state.nameExists ||
                                    this.state.updatingRelationship
                                }
                                deleteText={this.props.t("unlink", { ns: "linked_entity/property_panel" })}
                                deleteClicked={() =>
                                    this.props.Unlink(
                                        this.props.SideData.RelationId
                                    )
                                }
                                deleteDisabled={this.props.SideData.isManagerAttributeRelation}
                                saving={this.state.updatingRelationship}
                                saveClicked={this.Save}
                                redoClicked={() => this.setDefault()}
                                hasErrors={!(
                                    this.state.disabled ||
                                    this.state.showDuplicateIdentifierError ||
                                    this.state.showError ||
                                    this.state.nameExists ||
                                    this.state.updatingRelationship
                                )}
                                errors={
                                    this.state.isReferenceAttributeExceedingLimit ?
                                    [
                                        t("max_attributes_exceeded", {
                                            limit: this.state.subscription?.maxAttributesPerApp,
                                            entitiesWithAttributeLimitExceeded: this.state.toEntity?.name
                                        })
                                    ]
                                    :
                                    []
                                }
                                ShowMoreButtons={false}
                            />
                        </div>

                        <div className="flex-grow-1 position-relative">
                            <div
                                className="top-0 bottom-0 left-0 right-0 position-absolute"
                                style={{
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                }}
                            >
                                <div className="p-2 pt-0 selectCardinality">
                                    {/* <h6 className="pt-2 mx-2">Cardinality and Link Settings</h6> */}
                                    <div className="m-2">
                                        <label className="form-label d-inline-block" htmlFor="sidebar-relation-identifier-field" required>
                                            {t("relation_identifier", { ns: "linked_entity/property_panel" })}
                                        </label>
                                        {
                                            this.state.showDuplicateIdentifierError &&
                                            <span className="text-danger">
                                                &nbsp;{t("relation_identified_used", { ns: "linked_entity/property_panel" })}
                                            </span>
                                        }
                                        <ErrorMessage
                                            valid={this.state.identifierError.isValid}
                                            error={this.state.identifierError.message} />
                                        <input
                                            name="relationIdentifier"
                                            id="sidebar-relation-identifier-field"
                                            className="form-control"
                                            value={this.state.relationIdentifier}
                                            onChange={this.handleRelationIdentifier}
                                            maxLength={64} />
                                    </div>
                                    <SelectedCardinality
                                        orgName={this.props.orgName}
                                        projectName={this.props.projectName}
                                        fromEntity={this.state.fromEntity}
                                        toEntity={this.state.toEntity}
                                        showSelected={false}
                                        selected={this.state.cardinality}
                                        firstEntityName={
                                            this.state.fromEntity.name
                                        }
                                        secondEntityName={
                                            this.state.toEntity.name
                                        }
                                        onClick={this.toggleCardinalityPopup}
                                        isAccessedFromWorkspace={this.props.isAccessedFromWorkspace}
                                        selectEntity={this.props.selectEntity}
                                    />

                                    {this.state.cardinality === "1-*" && (
                                        <>
                                            {
                                                !this.state.preventReferenceAttribute &&
                                                this.state.targetAttributes.length > 0 &&
                                                <div className="px-2 pt-3 checkbox">
                                                    <span htmlFor="showRefAttr">
                                                        <Checkbox
                                                            id="showRefAttr"
                                                            checked={this.state.showReferenceAttribute}
                                                            onChange={this.handleShowReferenceAttribute}
                                                            disabled={
                                                                this.props.SideData.isManagerAttributeRelation ||
                                                                this.state.preventReferenceAttribute
                                                            }
                                                        />
                                                        <span className="checkbox-label">
                                                            <span>
                                                                {
                                                                    t("form.reference_attribute.label", { ns: "linked_entity/create_link_dialog" })
                                                                }
                                                            </span>
                                                            <span className="fw-bolder">
                                                                &nbsp;{this.state.toEntity.name}
                                                            </span>
                                                            <span>?</span>
                                                        </span>
                                                    </span>
                                                </div>
                                            }

                                            {this.state.showReferenceAttribute && (
                                                <>
                                                    <div className="pt-3 d-flex checkbox-margin">
                                                        <DropDownList
                                                            data={this.state.targetAttributes.filter(attr => !!attr._id)}
                                                            textField="attributeName"
                                                            className="form-control-custom"
                                                            value={this.state.referencedAttribute}
                                                            name="referenceAttribute"
                                                            onChange={this.handleReferenceAttribute}
                                                            disabled={this.props.SideData.isManagerAttributeRelation}
                                                        />

                                                    </div>

                                                    <div className="text-nowrap">
                                                        <Checkbox
                                                            id="isReq"
                                                            name="isLookupRequired"
                                                            className="-1 checkbox-margin"
                                                            checked={this.state.isLookupRequired}
                                                            onChange={this.handleCheckbox}
                                                            disabled={this.state.fromEntity?._id === this.state.toEntity?._id}
                                                            label={this.props.t("required", { ns: "linked_entity/property_panel" })}
                                                        />
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )}
                                    {this.state.showAdditionalFields && (
                                        <>
                                            <div className="pb-3 mb-3 checkbox-margin checkbox">
                                                {/* {
                                                    this.props.showOrphanRecordFields &&
                                                    !this.isDeleteOrphanDisabled() && (
                                                        <label
                                                            htmlFor="del-orphan"
                                                            disabled={this.isDeleteOrphanDisabled()}
                                                            className="pt-3"
                                                        >
                                                            <Checkbox
                                                                id="del-orphan"
                                                                checked={this.state.shouldDeleteOrphanRecord}
                                                                disabled={this.isDeleteOrphanDisabled()}
                                                                name="shouldDeleteOrphanRecord"
                                                                onChange={this.handleDeleteOrphanRecord}
                                                            />
                                                            <span className="checkbox-label">
                                                                <span>Delete </span>
                                                                <span className="fw-bolder">{this.state.toEntity.name} </span>
                                                                <span>records when the
                                                                    parent </span>
                                                                <span className="fw-bolder">{this.state.fromEntity.name} </span>
                                                                <span>record is deleted.</span>
                                                            </span>
                                                        </label>
                                                    )
                                                }
                                                {
                                                    this.props.showOrphanRecordFields &&
                                                    this.state.cardinality === "1-1" && (
                                                        <label
                                                            htmlFor="del-other-orphan"
                                                            className="pt-3"
                                                        >
                                                            <Checkbox
                                                                id="del-other-orphan"
                                                                checked={this.state.deleteLinkingEntityOrphanRecord}
                                                                name="deleteLinkingEntityOrphanRecord"
                                                                onChange={this.handleDeleteOrphanRecord}
                                                            />
                                                            <span className="checkbox-label">
                                                                <span> Delete </span>
                                                                <span className="fw-bolder">{this.state.fromEntity.name}</span>
                                                                records when the
                                                                parent
                                                                <span className="fw-bolder">{this.state.toEntity.name}</span>
                                                                record is deleted.
                                                            </span>
                                                        </label>
                                                    )
                                                } */}

                                                <div className=" row border-top mt-3">
                                                    <div className="col-12">
                                                        <div className="form-label d-inline-block" required>
                                                            {this.props.t("relation_label", { ns: "linked_entity/property_panel" })}
                                                            <b className="mx-1">{this.state.fromEntity.name}</b>
                                                        </div>
                                                        <ErrorMessage
                                                            valid={this.state.reverseRelationLabelError.isValid}
                                                            error={this.state.reverseRelationLabelError.message} />
                                                        <div className="col-12">
                                                            <input
                                                                className="form-control"
                                                                key="relationName"
                                                                value={this.state.relationName}
                                                                onChange={this.handleRelationName}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="form-label d-inline-block" required>
                                                            {this.props.t("relation_label", { ns: "linked_entity/property_panel" })}
                                                            <b className="mx-1">{this.state.toEntity.name}</b>
                                                        </div>
                                                        <ErrorMessage
                                                            valid={this.state.relationLabelError.isValid}
                                                            error={this.state.relationLabelError.message} />
                                                        <div className="col-12">
                                                            <input
                                                                className="form-control"
                                                                key="reverseRelationName"
                                                                value={this.state.reverseRelationName}
                                                                onChange={this.handleReverseRelationName}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <ShowMore
                                        toggled={(o) => this.toggleFields(o)}
                                    ></ShowMore>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    async componentDidMount() {
        debugger;
        if (this.props.SideData && this.props.SideData.relationId) {
            await this.loadEntityRelation();
        }
        if (this.props.mutators) {
            this.props.mutators.setFormSaveFunction(() => this.Save);
        }
    }

    componentDidUpdate = async (props, state) => {
        debugger;
        if (
            this.props.SideData.relationId &&
            props.SideData.relationId !== this.props.SideData.relationId
        ) {            
            await this.loadEntityRelation();
        }

        if (this.props.mutators && this.state.disabled !== state.disabled) {
            this.props.mutators.setFormsWithChanges(prevValue => ({
                ...prevValue,
                linkedEntityForm: !this.state.disabled
            }))
        }

        if (state.disabled !== this.state.disabled) {
            this.props.setEditPanelChanged(this.state.disabled);
        }
    };

    loadEntityRelation = async () => {
        debugger;
        let subscription = this.state.subscription;
        if (subscription._id === undefined) {
            subscription = await getCurrentSubscriptionForOrganisation(this.props.organizationId);
        }
        const { lookupAttribute } = this.props.SideData;
        /**/
        let defaultData = {
            ...this.props.SideData,
            showDuplicateIdentifierError: false,
            isLookupRequired: isNullOrUndefined(lookupAttribute) || lookupAttribute.required === true,
            newCardinality: this.props.SideData.cardinality,
        };

        // cardinality check is required because we set referencedAttribute property only if it is 1-*
        if (defaultData.cardinality === "1-*" && !defaultData.referencedAttribute._id) {
            defaultData.referencedAttribute = DEFAULT_REFERENCED_ATTRIBUTE;
        }

        if (defaultData.showReferenceAttribute === undefined) {
            defaultData.showReferenceAttribute = false;
        }

        this.defaultData = defaultData;

        // let otherEntityId = "";

        const preventReferenceAttribute = (
            (
                this.props.allData.findIndex(
                    (le) =>
                        le.relationId !== this.props.SideData.relationId &&
                        le.fromEntity._id ===
                        this.props.SideData.fromEntity._id &&
                        le.toEntity._id === this.props.SideData.toEntity._id
                ) > -1
            )
        ) || this.props.SideData.fromEntity.isUserEntity;

        if (
            this.defaultData.cardinality === "1-*"
        ) {
            this.getAttributes()
                .then(this.setReferenceAttribute);
        }

        this.setState({
            ...defaultData,
            preventReferenceAttribute,
            isRelationNameInUse: false,
            contradictiveRelationError: {
                isValid: true,
                message: ""
            },
            disabled: true,
            subscription
        });
    }

    copyLinkedEntityLink = () => {
        let url = `${process.env.REACT_APP_DESIGNER_URL}/${this.props.orgName}/${this.props.projectName}/Entities/${this.props.sysName}/LinkedEntities/${this.props.SideData.relationId}`;
        navigator.clipboard.writeText(url);
    };

    toggleFields = (val) => {
        this.setState({
            showAdditionalFields: val,
        });
    };

    toggleCardinalityPopup = () => {
        if (!this.props.SideData.isManagerAttributeRelation) {
            this.setState({
                showChangeCardinalityPopup: !this.state.showChangeCardinalityPopup,
            });
        }
    };

    isCardinalityChanged = () => {
        if (this.state.contradictiveRelationError.isValid) {
            return this.state.cardinality === this.state.newCardinality;
        } else {
            return true
        }
    };

    updateCardinality = () => {
        this.setState({
            cardinality: this.state.newCardinality,
        }, () => {
            this.setDisabled();
        });
        this.toggleCardinalityPopup();
    };

    handleCardinality = (newCardinality) => {
        let { contradictiveRelationError } = this.state
        const exists = checkIfContradictiveRelationsExist(
            this.props.allData,
            {
                fromEntity: this.state.fromEntity,
                toEntity: this.state.toEntity,
                cardinality: newCardinality,
                relationId: this.state.relationId
            }
        )
        if (exists) {
            contradictiveRelationError.isValid = false
            contradictiveRelationError.message = `One to Many relation is not allowed if you've already had a Many to One relation between the same pair of ${ENTITY_PLURAL_LABEL.toLowerCase()}.`
        } else {
            contradictiveRelationError.isValid = true
            contradictiveRelationError.message = ""
        }
        this.setState({
            newCardinality,
            contradictiveRelationError,
        });
    };

    checkIfContradictiveRelationExistsFor = (cardinality) => {
        if (cardinality === "1-*") {
            const { allData: relations } = this.props;
            const {
                fromEntity: { id: fromEntityId },
                toEntity: { id: toEntityId },
            } = this.state;
            const contradictiveRelationIndex = relations.findIndex(
                (relation) =>
                    relation.fromEntity._id === toEntityId &&
                    relation.toEntity._id === fromEntityId &&
                    relation.cardinality === "1-*"
            );
            return contradictiveRelationIndex > -1;
        }
        return false;
    };

    handleCheckbox = (e) => {
        const { name } = e.target;
        if (name === "isLookupRequired") {
            // this.handleDeleteOrphanRecord({
            //     target: {
            //         element: {
            //             current: {
            //                 name: "shouldDeleteOrphanRecord",
            //             },
            //         },
            //     },
            //     value: true,
            // });
        }
        this.setState({ [name]: e.value }, () => {
            this.setDisabled();
        });
    };

    handleRelationName = (e) => {
        let { relationLabelError } = this.state
        if (e.target.value.trim() === "") {
            relationLabelError.isValid = false
            relationLabelError.message = "Label is required"
        } else {
            relationLabelError.isValid = true
            relationLabelError.message = ""
        }
        this.setState({
            relationLabelError: relationLabelError,
            relationName: e.target.value,
        }, () => {
            this.setDisabled();
        });
    };

    handleReverseRelationName = (e) => {
        let { reverseRelationLabelError } = this.state
        if (e.target.value.trim() === "") {
            reverseRelationLabelError.isValid = false
            reverseRelationLabelError.message = "Label is required"
        } else {
            reverseRelationLabelError.isValid = true
            reverseRelationLabelError.message = ""
        }
        this.setState({
            reverseRelationLabelError: reverseRelationLabelError,
            reverseRelationName: e.target.value
        }, () => {
            this.setDisabled();
        });
    };

    handleRelationIdentifier = (e) => {
        let { identifierError } = this.state
        const newValue = e.target.value ? e.target.value.slice(0, e.target.maxLength) : "";
        const relationWithSameIdentifier = this.props.allData.findIndex(relation => (
            relation.relationIdentifier === newValue &&
            relation._id !== this.state.relationId
        )) > -1;
        if (newValue.trim() === "") {
            identifierError.isValid = false
            identifierError.message = "Relation name is required"
        } else {
            identifierError.isValid = true
            identifierError.message = ""
        }

        this.setState({
            identifierError: identifierError,
            relationIdentifier: newValue,
            showDuplicateIdentifierError: relationWithSameIdentifier
        }, this.setDisabled)
    }

    handleShowReferenceAttribute = (e) => {
        const showReferenceAttribute = e.target.value;
        this.setState(
            {
                showReferenceAttribute: e.value,
                referencedAttribute: {
                    attributeName: `Select ${ATTRIBUTE_LABEL}`,
                    _id: "",
                    rel_id: "",
                },
                attributesLoading: true,
                isLookupRequired: false,
                isReferenceAttributeExceedingLimit: false
            },
            () => {
                this.setDisabled();
                if (showReferenceAttribute) {
                    this.getAttributes()
                        .then(this.setReferenceAttribute);
                }
            }
        );
    };

    validateReferenceAttributeExceedsSubscriptionLimit = async () => {
        const { toEntity, showReferenceAttribute, subscription } = this.state;
        if (showReferenceAttribute) {
            const attributes = await getAttributes(toEntity._id);
            const nonSystemAttributes = attributes.filter(attr => !attr.isSystemAttribute);
            const limit = subscription?.maxAttributesPerApp;
            const isExceeding = nonSystemAttributes.length + 1 > limit;
            this.setState({
                isReferenceAttributeExceedingLimit: isExceeding,
                showUpgradeDialog: isExceeding,
                updatingRelationship: false
            }, () => {
                this.setDisabled()
            });
        } else {
            this.setState({
                isReferenceAttributeExceedingLimit: false,                
                updatingRelationship: false
            }, () => {
                this.setDisabled()
            });
        }
    }

    handleReferenceAttribute = (e) => {
        this.setState({
            referencedAttribute: e.target.value,
            disabled: true,
            // this is turned true to show loader while validating reference attribute limit
            // this will be set to false after validation in the validateReferenceAttributeExceedsSubscriptionLimit method
            updatingRelationship: true
        }, () => {
            this.validateReferenceAttributeExceedsSubscriptionLimit();
        });
    };

    isDeleteOrphanDisabled = () => {
        const { cardinality, isLookupRequired } = this.state;
        if (cardinality === "1-*") {
            return isLookupRequired;
        }
        return false;
    };

    handleDeleteOrphanRecord = (e) => {
        const { name } = e.target.element.current;
        this.setState({ [name]: e.value }, () => {
            this.setDisabled();
        });
    };

    setDisabled = () => {
        let disabled = true;

        let isRelationNameEmpty = this.state.relationName.trim() === "";
        let isReverseRelationNameEmpty = this.state.reverseRelationName.trim() === "";
        let isReferenceAttributeNotSelected = this.state.showReferenceAttribute && this.state.referencedAttribute && this.state.referencedAttribute._id === "";
        let isCardinalitySame = this.defaultData.cardinality === this.state.cardinality;
        let isRelationNameSame = this.defaultData.relationName === this.state.relationName;
        let isReverseRelationNameSame = this.defaultData.reverseRelationName === this.state.reverseRelationName;
        let isShowReferenceAttributeSame = this.defaultData.showReferenceAttribute === this.state.showReferenceAttribute;
        /**/
        let isReferenceAttributeSame = this.defaultData.referencedAttribute && this.defaultData.referencedAttribute._id === this.state.referencedAttribute._id;
        const isLookupRequiredSame = this.state.isLookupRequired === this.defaultData.isLookupRequired;
        const isIdentifierSame = this.state.relationIdentifier === this.defaultData.relationIdentifier;
        let isDataUnchanged =
            isCardinalitySame &&
            isRelationNameSame &&
            isReverseRelationNameSame &&
            isShowReferenceAttributeSame &&
            isReferenceAttributeSame &&
            isIdentifierSame &&
            isLookupRequiredSame;

        let { showError, showDuplicateIdentifierError } = this.state;

        if (
            isReverseRelationNameEmpty ||
            isRelationNameEmpty ||
            isReferenceAttributeNotSelected ||
            showError ||
            showDuplicateIdentifierError ||
            isDataUnchanged ||
            this.state.isReferenceAttributeExceedingLimit ||
            !this.state.identifierError.isValid ||
            !this.state.reverseRelationLabelError.isValid ||
            !this.state.relationLabelError.isValid
        ) {
            disabled = true;
        } else {
            disabled = false;
        }

        this.setState({ disabled });        
    };

    toggleDeleteReferencesPopup = (e) => {
        this.setState({
            showDeleteReferences: !this.state.showDeleteReferences,
        });
    };

    deleteReferences = (e) => {
        let options = {
            linkedEntityRelationId: this.props.SideData.relationId,
        };

        callApiWithAuthorization("/api/v0/removeReferenceFromComponents", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(options),
        });

        this.defaultData.cardinality = this.state.cardinality;

        this.toggleDeleteReferencesPopup();

        this.Save(e);
    };

    Save = async (e) => {
        try {
            if (e && e.preventDefault) {
                e.preventDefault();
            }
            this.setState({
                updatingRelationship: true
            })
            debugger;
            let properties = {
                cardinality: this.state.cardinality,
                relationName: this.state.relationName,
                sysRelationName: this.props.SideData.sysRelationName,
                sysReverseRelationName: this.props.SideData.sysReverseRelationName,
                reverseRelationName: this.state.reverseRelationName,
                order: this.props.SideData.order,
                showReferenceAttribute: this.state.showReferenceAttribute,
                identifier: this.state.relationIdentifier
            };

            // if (
            //     this.defaultData.isLookupRequired !== this.state.isLookupRequired &&
            //     properties.cardinality === "1-*" &&
            //     this.state.referencedAttribute.id &&
            //     this.state.referencedAttribute.id === this.defaultData.referencedAttribute.id
            // ) {
            //     await updateNode("Attribute", this.state.referencedAttribute.id, {
            //         required: String(this.state.isLookupRequired)
            //     });
            // }

            if (
                this.defaultData.cardinality === "1-*" &&
                properties.cardinality !== "1-*"
            ) {
                properties.showReferenceAttribute = false;
            }

            if (properties.cardinality === "1-1") {
                properties.deleteLinkingEntityOrphanRecord =
                    this.state.deleteLinkingEntityOrphanRecord;
            } else {
                properties.deleteLinkingEntityOrphanRecord = false;
            }

            await updateEntityRelation(this.state.relationId, properties);

            let { order } = properties;

            // await updateRelationWithProperty('InheritsLinkedEntity', 'inheritedFrom', this.state.relationId, toUpdateInInheritedRels);

            // Following was removed because we moved display to mongodb so relationship is not required
            // await updateRelationWithProperty("Displays", "relId", this.state.relationId, {
            //     relName: this.state.relationName,
            // });

            debugger;
            if (
                !properties.showReferenceAttribute &&
                this.defaultData.showReferenceAttribute
            ) {
                await deleteEntityRelationReferenceAttribute(this.state.relationId);
                properties.referencedAttribute = {};
            }

            if (
                properties.showReferenceAttribute &&
                this.defaultData.referencedAttribute._id !==
                this.state.referencedAttribute._id &&
                this.state.referencedAttribute._id
            ) {
                if (this.defaultData.referencedAttribute._id) {
                    await deleteEntityRelationReferenceAttribute(this.state.relationId);
                }
                const referenceAttribute = await this.createReferencedAttribute(
                    this.state.relationId
                );
                if (referenceAttribute.status === "Failure") {
                    this.setState({ showUpgradeDialog: true, updatingRelationship: false });
                    return;
                }
                properties.referencedAttribute = this.state.referencedAttribute;
                properties.lookupAttribute = referenceAttribute;
                properties.isLookupRequired = properties.lookupAttribute.required;
            }

            if (this.defaultData.isLookupRequired !== this.state.isLookupRequired) {
                const lookupAttributeId = properties.lookupAttribute && properties.lookupAttribute._id ? properties.lookupAttribute._id : this.defaultData.lookupAttribute._id;
                await updateAttribute(lookupAttributeId, {
                    required: this.state.isLookupRequired
                });
            }

            this.defaultData = {
                ...this.defaultData,
                ...properties,
                isLookupRequired: this.state.isLookupRequired,
                relationIdentifier: properties.identifier
            };
            if (this.defaultData.lookupAttribute && typeof this.defaultData.lookupAttribute === "object") {
                this.defaultData.lookupAttribute = {
                    ...this.defaultData.lookupAttribute,
                    required: this.defaultData.isLookupRequired
                }
            }

            this.setState({ disabled: true, updatingRelationship: false }, () => {
                this.props.updateElement(this.defaultData);
            });
        } catch (error) {
            console.error(error);
        } finally {
            if (this.props.mutators && this.props.mutators.setFormsWithChanges) {
                this.props.mutators.setFormsWithChanges(prevValue => ({
                    ...prevValue,
                    linkedEntityForm: true
                }));
            }
        }
    };

    createReferencedAttribute = async (linkedEntityRelationId) => {
        const { fromEntity, toEntity, referencedAttribute, isLookupRequired } = this.state;
        const { projectId } = this.props;

        const properties = {
            attributeName: `[REF] ${this.state.referencedAttribute.attributeName}`,
            attributeLabel: this.state.referencedAttribute.attributeLabel,
            primary: "false",
            required: isLookupRequired,
            readOnly: false,
            attributeType: "Entity Lookup",
            group: "",
            linkedEntityId: linkedEntityRelationId,
            entityAttributeRelId: this.state.referencedAttribute.rel_id,
            tooltip: this.state.referencedAttribute.attributeName,
            description: "",
            defaultValue: "",
        };
        const parentEntityId = toEntity._id;
        const referencedAttributeId = this.state.referencedAttribute._id;

        const referenceAttribute = await createReferenceAttribute({
            organizationId: this.props.organizationId,
            projectId: projectId,
            entityRelationId: linkedEntityRelationId,
            parentEntityId: parentEntityId,
            referencedEntityId: fromEntity._id,
            referencedAttributeId: referencedAttributeId,
            attributeProperties: properties
        })

        // const request = await callApiWithAuthorization(
        //     "/api/v0/entity/" +
        //     parentEntityId +
        //     "/referenceAttributeAndConfig",
        //     {
        //         method: "POST",
        //         headers: {
        //             "Content-Type": "application/json",
        //         },
        //         body: JSON.stringify({
        //             properties,
        //             projectId,
        //             parentEntityId,
        //             referencedAttributeId,
        //             linkedEntityRelationId,
        //         }),
        //     }
        // );

        // const attribute = await request.json();

        // addToChangeHistory(projectId, {
        //     action: "add",
        //     resource: "attribute",
        //     resourceId: attribute.id,
        //     resourceParentId: toEntity.id,
        // });

        // updateNode("Project", projectId, { hasSchemaChanges: true })

        return referenceAttribute;
    };

    getAttributes = async (e) => {
        const { _id: targetEntityId } = this.props.SideData.fromEntity;
        // let entityIdOfAttributes = this.props.SideData.reversed ? this.props.SideData.startNodeId : this.props.SideData.endNodeId;
        let allAttributes = this.entityAttributeMap[targetEntityId];
        if (!allAttributes) {
            allAttributes = await getAttributes(targetEntityId);
            this.entityAttributeMap[targetEntityId] = allAttributes;
        }
        const targetAttributes = allAttributes.filter((attr) => (attr.attributeType === "String" || attr.attributeType === "Custom Id") && !attr.isSystemAttribute);

        return targetAttributes;
    };

    setReferenceAttribute = (attributes) => {
        debugger;
        let defaultAttribute = {};
        if (
            this.props.SideData.referencedAttribute &&
            this.props.SideData.referencedAttribute._id
        ) {
            defaultAttribute = attributes.find(
                (attribute) =>
                    attribute._id === this.props.SideData.referencedAttribute._id
            ) || DEFAULT_REFERENCED_ATTRIBUTE;
        } else if (attributes.length > 0 && this.state.showReferenceAttribute) {
            defaultAttribute = attributes[0];
        } else {
            defaultAttribute = DEFAULT_REFERENCED_ATTRIBUTE;
        }


        this.setState({
            targetAttributes: attributes,
            attributesLoading: false,
            referencedAttribute: defaultAttribute,
        }, () => {
            this.setDisabled()
        });
    }

    getDisabled = () => {
        return this.state.disabled;
    };

    continueWithoutSaving = (selectNext) => {
        this.setState({ disabled: true }, () => {
            selectNext();
        });
    };

    setDefault = () => {
        let { defaultData } = this;
        defaultData.disabled = true;
        this.setState(defaultData);
    };
}

export default withTranslation("linked_entity/property_panel", { withRef: true })(LinkedEntitySidebar);